module.exports = __webpack_public_path__ + "img/Logo.Dark.WhiteBG1@2x.9f113fda.png";